import { render, staticRenderFns } from "./openingMenu.vue?vue&type=template&id=73d68f40&scoped=true"
import script from "./openingMenu.vue?vue&type=script&lang=js"
export * from "./openingMenu.vue?vue&type=script&lang=js"
import style0 from "./openingMenu.vue?vue&type=style&index=0&id=73d68f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d68f40",
  null
  
)

export default component.exports